import styled from "styled-components";

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: ${(props) => props.theme.zIndex.modal};

  width: 100%;
  height: 100%;

  background: ${(props) => props.theme.colors.text};
  opacity: 0.5;
`;

export default ModalOverlay;
